import { render, staticRenderFns } from "./SamEmptyState.vue?vue&type=template&id=c161372a&scoped=true&shadow"
import script from "./SamEmptyState.vue?vue&type=script&lang=js&shadow"
export * from "./SamEmptyState.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamEmptyState.vue?vue&type=style&index=0&id=c161372a&prod&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c161372a",
  null
  ,true
)

export default component.exports